<template lang="pug">
  .status-pill(
    :class="variantClass"
    role="status"
  )
    i.status-pill-icon.hi(:class="[icon, iconRotation]")
    span.status-pill-text(:title="text")
      | {{ text }}:
    span.status-pill-value {{ value }}
</template>

<script>
export default {
  name: 'InsightsUtilizationWidgetStatusPill',
  props: {
    variant: { type: String, default: 'bad' }, // bad | warn | ok
    icon: { type: String, required: true },
    iconRotation: { type: String, default: '' },
    text: { type: String, required: true },
    value: { type: String, required: true },
  },
  computed: {
    variantClass() {
      return `status-pill-${this.variant}`;
    },
  },
};
</script>
